const GET_BRANCH_DROP_DOWN_LIST = 'GET_BRANCH_DROP_DOWN_LIST';
const SET_BRANCH_DROP_DOWN_LIST = 'SET_BRANCH_DROP_DOWN_LIST';

export {
    GET_BRANCH_DROP_DOWN_LIST,
    SET_BRANCH_DROP_DOWN_LIST
};